import styled from 'styled-components';

const Content = styled.div`
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  ${({ noPadding }) =>
    noPadding ? '' : `padding: 0 var(--content-x-padding);`};
`;

export default Content;
